import { gql } from "graphql-request";

export const DELETE_AUDIT_QUESTION = gql`
  mutation DeleteAuditQuestion($id: ID!) {
    deleteAuditQuestion(id: $id)
  }
`;

export const CREATE_AUDIT_QUESTION = gql`
  mutation CreateAuditQuestion($input: CreateAuditQuestionInput!) {
    createAuditQuestion(input: $input) {
      id
      industry
      area
      statement
      description
      sortOrder
      isActive
      isHighImpact
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_AUDIT_QUESTION = gql`
  mutation UpdateAuditQuestion($input: UpdateAuditQuestionInput!) {
    updateAuditQuestion(input: $input) {
      id
      industry
      area
      statement
      description
      sortOrder
      isActive
      isHighImpact
      createdAt
      updatedAt
    }
  }
`;